import * as React from 'react'
import { useNavigate } from 'react-router-dom'

import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import { useGoal } from 'modules/goals/hooks/useGoal'

export const DeleteGoalModal: React.FC<{ id: string; onClose: () => void }> = ({ id, onClose }) => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  const { loading, goalConfig } = useGoal(Number(id))

  const { performAction: onDelete } = useAsyncAction(async () => {
    await goalConfig?.destroy()
    onClose()
    navigate(navigation.performance.goals.fullPath())
  })

  if (loading) return null

  return (
    <Modal
      illustration="alert"
      title={i18n.t('surveys.goals.delete.title', {
        name: goalConfig?.attributes.name,
      })}
      description={i18n.t('surveys.goals.delete.description')}
      onClose={onClose}
      onSubmit={onDelete}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button type="negative" submit>
            {i18n.t('surveys.goals.delete.delete')}
          </Button>
        </>
      }
    />
  )
}
